const element = document.querySelector('.title-menu-dropdown'); 
const targetelement = document.querySelector('html'); 
const targetelement2 = document.querySelector('.verticalmenu-list');
const verticalelement = document.querySelector('.vertical-menu');
const delayInMilliseconds = 3000;
// Check if the element exists
if (targetelement) {
    // Function to run when the mouse enters (hovers over)
    element.addEventListener('mouseover', function() {
        // Add the secondary CSS class
       verticalelement.classList.add('open');
     targetelement.classList.add('vetical-overlay');
             console.log('Hover style added!');
    });
    

    // Function to run when the mouse leaves (stops hovering)
element.addEventListener('mouseout', function() {
    // Set a timeout to delay the execution of the code inside
    setTimeout(function() {
        // Check if the target element is NOT being hovered over anymore
        // This check is crucial because the mouse might have moved onto
        // 'targetelement' or back onto 'element' during the delay.
        if (!verticalelement.matches(':hover') && !targetelement2.matches(':hover') && !element.matches(':hover')) {
            
    verticalelement.classList.remove('open');
     targetelement.classList.remove('vetical-overlay');
        }
        // If it IS being hovered over (meaning the mouse returned during the delay), 
        // the function exits without removing the class.
    }, 1000); // The delay in milliseconds (500ms = 0.5 seconds)
});

verticalelement.addEventListener('mouseout', function() {
    // Set a timeout to delay the execution of the code inside
    setTimeout(function() {
        // Check if the target element is NOT being hovered over anymore
        // This check is crucial because the mouse might have moved onto
        // 'targetelement' or back onto 'element' during the delay.
        if (!verticalelement.matches(':hover') && !targetelement2.matches(':hover') && !element.matches(':hover')) {
           
    verticalelement.classList.remove('open');
     targetelement.classList.remove('vetical-overlay');
        }
        // If it IS being hovered over (meaning the mouse returned during the delay), 
        // the function exits without removing the class.
    }, 1000); // The delay in milliseconds (500ms = 0.5 seconds)
});

}